var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Typography from '../../Styles/Typography/Typography';
import Spacer from '../../Layout/Spacer/Spacer';
const ContainerStyle = styled.div `
  font-family: ${props => props.theme.fonts.fontFamily};
  box-sizing: border-box;
  width: ${(props) => (props.width ? props.width : '100%')};
`;
const TableContainerStyle = styled.div `
  overflow-y: auto;
  max-height: ${(props) => (props.height ? props.height : 'auto')};
  margin: ${props => props.theme.paddingsMargins.themeMargin};
  box-shadow: ${(props) => (props.noShadow ? 0 : props.theme.boxes.boxShadow)};
  border: ${(props) => (props.noShadow ? props.theme.utils.borderColor(props.theme.utils.getColor('grey')) : 0)};
  border-radius: ${props => props.theme.borders.borderRadius};
`;
const TableContainer = (_a) => {
    var { color = 'main', titleSize = 'subTitle', width, height, title, noShadow = false, children } = _a, props = __rest(_a, ["color", "titleSize", "width", "height", "title", "noShadow", "children"]);
    return (_jsxs(ContainerStyle, Object.assign({ width: width }, props, { children: [title && (_jsxs(_Fragment, { children: [_jsx(Typography, Object.assign({ color: color, size: titleSize }, { children: title })), _jsx(Spacer, { vertical: true })] })), _jsx(TableContainerStyle, Object.assign({ noShadow: noShadow, height: height }, { children: children }))] })));
};
export default TableContainer;
